<template>
  <div>
    <b-card class="rounded-lg">
      <b-card-header>
        <h4>{{ $t('accounting_my_wallet_title') }}</h4>
      </b-card-header>
      <b-card-body>
        <div
          v-if="loading"
          class="text-center"
        >
          <b-spinner
            variant="primary"
            :label="$t('common.loading')"
          />
        </div>
        <div v-else-if="walletData">
          <b-row>
            <b-col
              cols="12"
              md="4"
            >
              <b-card class="text-center">
                <h5 class="text-muted mb-2">
                  {{ $t('accounting_my_wallet_balance') }}
                </h5>
                <h3 class="mb-0">
                  {{ formatCurrency(walletData.balance || 0) }}
                </h3>
              </b-card>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <b-card class="text-center">
                <h5 class="text-muted mb-2">
                  {{ $t('accounting_my_wallet_total_income') }}
                </h5>
                <h3 class="text-success mb-0">
                  {{ formatCurrency(walletData.total_income || 0) }}
                </h3>
              </b-card>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <b-card class="text-center">
                <h5 class="text-muted mb-2">
                  {{ $t('accounting_my_wallet_total_expenses') }}
                </h5>
                <h3 class="text-danger mb-0">
                  {{ formatCurrency(walletData.total_expenses || 0) }}
                </h3>
              </b-card>
            </b-col>
          </b-row>
          <b-card class="mt-3">
            <h5 class="mb-3">
              {{ $t('accounting_my_wallet_recent_transactions') }}
            </h5>
            <b-table
              v-if="transactions && transactions.length > 0"
              striped
              :items="transactions"
              :fields="transactionFields"
              responsive
            >
              <template #cell(transaction_date)="data">
                {{ formatDate(data.item.transaction_date) }}
              </template>
              <template #cell(amount)="data">
                <span :class="data.item.type === 'income' ? 'text-success' : 'text-danger'">
                  {{ data.item.type === 'income' ? '+' : '-' }}{{ formatCurrency(data.item.amount) }}
                </span>
              </template>
              <template #cell(type)="data">
                <b-badge :variant="data.item.type === 'income' ? 'success' : 'danger'">
                  {{ $i18n.locale === 'ar' ? (data.item.type_label_ar || data.item.type) : (data.item.type_label || data.item.type) }}
                </b-badge>
              </template>
            </b-table>
            <div
              v-else
              class="text-center text-muted py-4"
            >
              {{ $t('accounting_my_wallet_no_transactions') }}
            </div>
          </b-card>
        </div>
        <div
          v-else
          class="text-center text-muted py-4"
        >
          {{ $t('accounting_my_wallet_no_data') }}
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BSpinner,
  BTable,
  BBadge,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BSpinner,
    BTable,
    BBadge,
  },
  data() {
    return {
      loading: false,
      walletData: null,
      transactions: [],
    }
  },
  computed: {
    transactionFields() {
      return [
        { key: 'transaction_date', label: this.$t('accounting_transactions_date') },
        { key: 'description', label: this.$t('accounting_transactions_description') },
        { key: 'type', label: this.$t('accounting_transactions_type') },
        { key: 'amount', label: this.$t('accounting_transactions_amount') },
      ]
    },
  },
  mounted() {
    this.loadWalletData()
  },
  methods: {
    formatCurrency(amount, currency = 'EGP') {
      const locale = this.$i18n.locale === 'ar' ? 'ar-EG' : 'en-US'
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(amount)
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString(this.$i18n.locale === 'ar' ? 'ar-EG' : 'en-US')
    },
    async loadWalletData() {
      this.loading = true
      try {
        // TODO: Replace with actual API call when backend endpoint is available
        // const response = await walletAPI.getMyWallet();
        // this.walletData = response.data;
        // this.transactions = response.data.transactions || [];

        // Placeholder data structure
        this.walletData = {
          balance: 0,
          total_income: 0,
          total_expenses: 0,
        }
        this.transactions = []
      } catch (error) {
        console.error('Error loading wallet data:', error)
        this.$bvToast.toast(this.$t('accounting_my_wallet_load_error'), {
          title: this.$t('common.error'),
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
</style>
